import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { ButtonFooterComponent } from './button-footer/button-footer.component';
import { CardComponent } from './card/card.component';
import { CopyRightComponent } from './copy-right/copy-right.component';
import { ImgComponent } from './img/img.component';
import { IntroComponent } from './intro/intro.component';
import { ItemComponent } from './item/item.component';
import { LineComponent } from './line/line.component';
import { ListComponent } from './list/list.component';
import { LogoComponent } from './logo/logo.component';
import { ProfileComponent } from './profile/profile.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { SquareButtonComponent } from './square-button/square-button.component';
import { RowComponent } from './row/row.component';
import { ImgSlidesComponent } from './img-slides/img-slides.component';



@NgModule({
  declarations: [
    ButtonFooterComponent,
    CardComponent,
    CopyRightComponent,
    ImgComponent,
    ImgSlidesComponent,
    IntroComponent,
    ItemComponent,
    LineComponent,
    ListComponent,
    LogoComponent,
    ProfileComponent,
    RowComponent,
    SpinnerComponent,
    SquareButtonComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    PipesModule,
    RouterModule
  ],
  exports: [
    ButtonFooterComponent,
    CardComponent,
    CopyRightComponent,
    ImgComponent,
    ImgSlidesComponent,
    IntroComponent,
    ItemComponent,
    LineComponent,
    ListComponent,
    LogoComponent,
    ProfileComponent,
    RowComponent,
    SpinnerComponent,
    SquareButtonComponent
  ]
})
export class LayoutModule { }
